import angular from 'angular';
import DisableCopyPasteDirective from './disable-copy-paste.directive';

let DisableCopyPasteModule = angular.module('disable-copy-paste-module', [])
    .directive('disableCopyPaste', DisableCopyPasteDirective)
    .name;

export default DisableCopyPasteModule;



// WEBPACK FOOTER //
// ./client/app/common/disable-copy-paste/index.js